import React, { Component } from "react";
import { Form } from "semantic-ui-react";
import {CKEditor} from 'ckeditor4-react';

import { baseUrl } from "../../../utils/constants";

CKEditor.editorUrl = `${baseUrl}/plugins/ckeditor/ckeditor.js`;

class FoundationInfo extends Component {
  render() {
    return (
      <Form>
        <Form.Field>
          <label>Foundation Information:</label>
          <CKEditor
            config={{
              toolbarGroups: [
                { name: 'clipboard',   groups: [ 'clipboard', 'undo' ] },
                { name: 'editing',     groups: [ 'find', 'selection' ] },
                { name: 'links' },
                { name: 'insert' },
                { name: 'forms' },
                { name: 'tools' },
                { name: 'document',	   groups: [ 'mode', 'document', 'doctools' ] },
                { name: 'others' },
                '/',
                { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
                { name: 'paragraph',   groups: [ 'list', 'indent', 'blocks', 'align' ] },
                { name: 'styles' },
                { name: 'colors' }
              ],
              removeButtons:'',
              format_tags: 'p;h1;h2;h3;pre',
              removeDialogTabs: 'image:advanced;link:advanced'
            }}
            initData={this.props.profile.information}
            onChange={this.props.handleChange}
          />
        </Form.Field>

        <Form.Group inline>
          <Form.Button
            size="large"
            onClick={() => this.props.handleStep("contact-info")}
          >
            Go Back{" "}
          </Form.Button>
          <Form.Button
            primary
            size="large"
            onClick={() => this.props.handleSubmit()}
          >
            Save And Continue{" "}
          </Form.Button>
        </Form.Group>
      </Form>
    );
  }
}

export default FoundationInfo;
